import { Box, Flex, Image, Text } from "@chakra-ui/react";
import NoCover from "../../components/NoCover/NoCover";
import img6 from "../../../../assets/images/img-6.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../../config";
import FavoriteButton from "../AllEventsPage/FavoriteButton";
import { isFavorite } from '../AllEventsPage/cookie-utils';
import SharePopover from "../../../../shared/components/Share/SharePopover";

const EventDetailHeaderPage = ({ event, social = true, onFavoriteToggle, onImageClick }) => {
    const navigate = useNavigate();
    const { t } = useTranslation("default");
    const baseURL = BASE_URL;

    const handleNavigate = (route, options = {}) => {
        navigate(route, options);
    };

    const handleEvents = () => {
        handleNavigate("/");
    };

    const formattedDate = (date) => {
        if (!date) return '';
        const formattedDate = new Intl.DateTimeFormat('pl-PL', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        }).format(date);
        return formattedDate;
    }

    const eventDate = (event) => {
        if (!event?.startDate) return '';
        if (event.startDate === event.endDate) {
            return `${formattedDate(new Date(event.startDate))}, ${event.startTime}–${event.endTime}`;
        }
        return `${formattedDate(new Date(event.startDate))}, ${event.startTime} – ${formattedDate(new Date(event.endDate))}, ${event.endTime}`;
    }

    const getImg = (event) => {
        const path = event?.coverImage;
        return path ? `${baseURL}/${path}` : img6;
    }

    return <Flex bgColor="#3A0F1B" color="white" w={"100%"} alignItems={"center"} justifyContent="center">
        <Flex flexDirection={'column'} gap={'16px'} w={{ base: '90%', sm: '7xl' }} alignItems={"flex-start"} py={{ base: '16px', md: '64px' }} justifyContent={"space-between"}>
            <Flex w={"100%"} gap="32px" flexDirection={{ base: 'column', md: 'row' }}>
                <Flex w={"100%"} gap="32px" flexDirection={{ base: 'column', md: 'row' }}>
                    {event?.coverImage ? (
                        <Image src={getImg(event)} alt={event.title} objectFit="contain" bg="#F8ECEF"
                            w="100%" maxW={{ base: '100%', md: '304px' }}
                            aspectRatio="16 / 9" h="auto" borderRadius={'8px'}
                            cursor="pointer" onClick={onImageClick} />
                    ) : (
                        <Box w="100%" maxW={{ base: '100%', md: '304px' }} flexShrink={0} aspectRatio="16 / 9" borderRadius="8px" overflow="hidden"><NoCover size="100%" h="100%" minH={0} /></Box>
                    )}
                    <Flex flexDirection={'column'} gap="16px">
                        <Flex gap={'8px'} alignItems={"flex-start"} fontFamily="body" fontWeight={'500'} fontSize='16px' color="#B5B5B5">
                            {event?.categories?.map((category, index) => (
                                <Flex key={index} alignItems="center">
                                    <Text>
                                        {category}
                                    </Text>
                                    {index < event.categories.length - 1 && (
                                        <Box mx={'4px'}>
                                            <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="2.55032" y="-0.050293" width="3.60669" height="3.60669" rx="1" transform="rotate(45 2.55032 -0.050293)" fill="#6E6064" />
                                            </svg>
                                        </Box>
                                    )}
                                </Flex>
                            ))}
                        </Flex>
                        <Text fontFamily="body" fontWeight={'600'} fontSize={{ base: '16px', md: '38px' }} lineHeight={'150%'} onClick={() => handleEvents()} cursor={"pointer"}>
                            {event?.title}
                        </Text>
                        <Flex flexDirection={'column'} gap="8px">
                            <Flex gap="12px" alignItems="center">
                                {event?.isOnline ? (
                                    <>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7A1F35" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                                        <Text>{event?.platform} {t('event.online', '(Wydarzenie online)')}</Text>
                                    </>
                                ) : (
                                    <>
                                        <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.657 14.9139L10.414 19.1569C10.2284 19.3427 10.0081 19.49 9.76556 19.5905C9.52303 19.6911 9.26305 19.7428 9.0005 19.7428C8.73796 19.7428 8.47798 19.6911 8.23544 19.5905C7.99291 19.49 7.77256 19.3427 7.587 19.1569L3.343 14.9139C2.22422 13.7951 1.46234 12.3696 1.15369 10.8178C0.845043 9.26594 1.00349 7.65742 1.60901 6.19564C2.21452 4.73385 3.2399 3.48445 4.55548 2.60542C5.87107 1.72638 7.41777 1.2572 9 1.2572C10.5822 1.2572 12.1289 1.72638 13.4445 2.60542C14.7601 3.48445 15.7855 4.73385 16.391 6.19564C16.9965 7.65742 17.155 9.26594 16.8463 10.8178C16.5377 12.3696 15.7758 13.7951 14.657 14.9139Z" stroke="#7A1F35" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M12 9.2569C12 10.0525 11.6839 10.8156 11.1213 11.3782C10.5587 11.9408 9.79565 12.2569 9 12.2569C8.20435 12.2569 7.44129 11.9408 6.87868 11.3782C6.31607 10.8156 6 10.0525 6 9.2569C6 8.46125 6.31607 7.69819 6.87868 7.13558C7.44129 6.57297 8.20435 6.2569 9 6.2569C9.79565 6.2569 10.5587 6.57297 11.1213 7.13558C11.6839 7.69819 12 8.46125 12 9.2569Z" stroke="#7A1F35" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <Text>{event?.address}</Text>
                                    </>
                                )}
                            </Flex>
                            <Flex gap="12px">
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 6.5V10.5L13 13.5M19 10.5C19 11.6819 18.7672 12.8522 18.3149 13.9442C17.8626 15.0361 17.1997 16.0282 16.364 16.864C15.5282 17.6997 14.5361 18.3626 13.4442 18.8149C12.3522 19.2672 11.1819 19.5 10 19.5C8.8181 19.5 7.64778 19.2672 6.55585 18.8149C5.46392 18.3626 4.47177 17.6997 3.63604 16.864C2.80031 16.0282 2.13738 15.0361 1.68508 13.9442C1.23279 12.8522 1 11.6819 1 10.5C1 8.11305 1.94821 5.82387 3.63604 4.13604C5.32387 2.44821 7.61305 1.5 10 1.5C12.3869 1.5 14.6761 2.44821 16.364 4.13604C18.0518 5.82387 19 8.11305 19 10.5Z" stroke="#7A1F35" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {eventDate(event)}
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
                {social && <Flex gap="16px">
                    <SharePopover
                        url={`https://evenado.com/event/${event.id}`}
                        title={event.title}
                    />
                    <FavoriteButton eventId={event.id} isFavorite={isFavorite(event.id)} onChange={onFavoriteToggle} />
                </Flex>}
            </Flex>
        </Flex>
    </Flex>
};

export default EventDetailHeaderPage;
